var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!this.isMobile)?_c('div',[(_vm.model === 'v1')?_c('ContadorDesktopV1'):_vm._e(),_vm._v(" "),(_vm.model === 'v2')?_c('ContadorDesktopV2'):_vm._e()],1):_vm._e(),_vm._v(" "),(this.isMobile)?_c('div',[(_vm.model === 'v1')?_c('ContadorMobileV1'):_vm._e(),_vm._v(" "),(_vm.model === 'v2')?_c('ContadorMobileV2'):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }